import { render, staticRenderFns } from "./upload-modal.vue?vue&type=template&id=b7b5c5b0"
import script from "./upload-modal.vue?vue&type=script&lang=js"
export * from "./upload-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports